class ScheduleCalendarController {

    constructor() {
        this.view = null;
    }

    populate(schedule) {
        if (this.view === null) {
            this.view = new ScheduleCalendarView(
                this.onEventChanged.bind(this),
                this.onEventAdd.bind(this));
        }
        this.schedule = schedule;
        this.view.clearCalendar();
        schedule.getItems().each(this.addToCalendar.bind(this));
        this.view.calendar.render();
        this.view.rootNode.find('.close').off('click').click(this.onRemoveEvent.bind(this));

        this.addTimeController = new AddTimeController(this.onAddTime.bind(this));
        this.schedule = schedule;
    }

    setPrintMode() {
        let startHr = 9;
        let endHr = 20;
        this.schedule.getItems().each(function (item) {
            if (item.getType() === ScheduleType.sleep) {
                return;
            }
            let startTime = item.getStartTime();
            let endTime = item.getEndTime();
            let itemStartHr = (startTime - (startTime % 60)) / 60;
            let itemEndHr = (endTime + (endTime % 60)) / 60;
            if (itemStartHr < startHr) {
                startHr = itemStartHr;
            }
            if (itemEndHr > endHr) {
                endHr = itemEndHr;
            }
        }.bind(this));
        startHr -= 1;
        endHr += 1;
        if(startHr < 0) {
            startHr = 0;
        }
        if(endHr > 24) {
            endHr = 24;
        }
        this.view.setStartEndHours(startHr, endHr);
        return endHr - startHr;
    }

    setWebMode() {
        this.view.setStartEndHours(0, 24);
    }

    addToCalendar(scheduleItem) {
        let duration = scheduleItem.getEndTime() - scheduleItem.getStartTime()
        let className = duration < 60 ? "short-duration" : "";
        let event = {
            id: scheduleItem.cid,
            title: this.view.getEventTitle(scheduleItem),
            start: this.toDateTime(scheduleItem.getDay(), scheduleItem.getStartTime()),
            end: this.toDateTime(scheduleItem.getDay(), scheduleItem.getEndTime()),
            color: this.view.getEventColor(scheduleItem),
            classNames: [className,]
        };
        this.view.calendar.addEvent(event);
    }

    onEventChanged(eventChangeInfo) {
        let event = eventChangeInfo.event;
        let eventId = event.id;
        let eventStart = event.start;
        let eventEnd = event.end;
        let scheduleItem = this.schedule.lookupById(eventId);
        scheduleItem.updateFromDateTimeObjects(eventStart, eventEnd);
        plannerApplication.scheduleUpdated();
        this.view.rootNode.find('.close').off('click').click(this.onRemoveEvent.bind(this));
    }

    onRemoveEvent(e) {
        let clicked = $(e.target);
        if (clicked.hasClass('icon-close')) {
            clicked = clicked.parent();
        }
        let eventId = clicked.attr('data-event-id');
        let event = this.view.calendar.getEventById(eventId);
        event.remove();
        let scheduleItem = this.schedule.lookupById(eventId);
        this.schedule.getItems().remove(scheduleItem);
        plannerApplication.scheduleUpdated();
    }

    onEventAdd(start, end) {
        if (start.getMinutes() !== 0) {
            start.setMinutes(0);
        }
        if (end.getTime() - start.getTime() < (60 * 60 * 1000)) {
            end.setTime(start.getTime() + (60 * 60 * 1000));
        }
        this.start = start;
        this.end = end;

        this.addTimeController.show();
    }

    onAddTime(scheduleType, otherInput) {
        let scheduleItem = CreateScheduleItemFromDateTimeObjects(scheduleType, this.start, this.end, otherInput);
        this.schedule.getItems().add(scheduleItem);
        this.addToCalendar(scheduleItem);
        this.view.rootNode.find('.close').off('click').click(this.onRemoveEvent.bind(this));
        plannerApplication.scheduleUpdated();
    }

    toDateTime(day, minutes) {
        let mins = minutes % 60;
        let hours = (minutes - mins) / 60;
        mins = mins < 10 ? '0' + mins : '' + mins;
        hours = hours < 10 ? '0' + hours : '' + hours;

        let date = toDateStr(CalendarReferenceDateYear, CalendarReferenceDateMonth, CalendarReferenceDateDay + day)
            + ' ' + hours + ':' + mins;
        return date;
    }
}
